import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses, bonusesCopy } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-white py-14 md:py-20" data-id="element-21" data-mp="pjg6429tfa1g">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-22" data-mp="avld0krwb3nu">
        <header className="mx-auto max-w-3xl text-center" data-id="element-23" data-mp="asz1ka1vw40c">
          <GiftIcon className="mx-auto h-8 w-8 text-blue-600 md:h-10 md:w-10" aria-hidden="true" data-id="element-24" data-mp="ft4r9kolfgfs" />
          <h2 className="mt-4 text-3xl font-extrabold leading-tight tracking-tight text-slate-900 md:text-5xl" data-id="element-25" data-mp="1tc582o0hoe5">
            {bonusesCopy.title}
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-blue-900/70" data-id="element-26" data-mp="3o1lhcx8wzvm3">{bonusesCopy.subtitle}</p>
        </header>

        <ul className="mx-auto mt-10 max-w-3xl divide-y divide-blue-100 overflow-hidden rounded-2xl bg-white shadow-sm ring-1 ring-blue-100" data-id="element-27" data-mp="3t06g0s8iq78f">
          {bonuses.map((bonus, index) => <li key={bonus.tag} className="flex items-start gap-4 px-5 py-4 md:gap-5 md:px-7" data-id="element-28" data-mp="1r9329u3c0cjn" data-mpi={index}>
              <span className="mt-0.5 text-2xl font-extrabold tracking-tight text-blue-200" data-id="element-29" data-mp="3ie6gdcxu9ttk">
                0{index + 1}
              </span>
              <div className="min-w-0 flex-1" data-id="element-30" data-mp="3dek4p7xnslmv">
                <h3 className="text-lg font-extrabold tracking-tight text-slate-900" data-id="element-31" data-mp="3r6qi4m9fgeim">
                  {bonus.title}
                </h3>
                <p className="mt-0.5 text-blue-900/75" data-id="element-32" data-mp="3n67r2ufczchh">{bonus.benefit}</p>
              </div>
              <span className="mt-0.5 shrink-0 rounded-lg bg-emerald-50 px-2.5 py-1 text-xs font-extrabold uppercase tracking-wide text-emerald-600" data-id="element-33" data-mp="2zesm0tw76h2j">
                {bonusesCopy.badge}
              </span>
            </li>)}
        </ul>

        <p className="mx-auto mt-6 max-w-2xl text-center text-lg font-bold text-blue-900/80" data-id="element-34" data-mp="38e5x1qzyzdpd">
          {bonusesCopy.closing}
        </p>
      </div>
    </section>;
}